import { required, numeric, maxLength } from 'vuelidate/lib/validators'
import { validateRegexData, validateRegexComputed } from './validateRegex'

const regexValida = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^[a-zA-Z0-9+_-]+$/g.test(value)
}

const regexValidaOrigem = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
      return true
  }
  return /^[a-zA-Z0-9+_-]+$|^\$\{nomeOrigem\}$/g.test(value)
}

export const validateData = {
  form: {
    ...validateRegexData,
    acao: {
      description: { required, maxLength: maxLength(35) },
      centroDeCusto: { required },
      tamanhoPrefixoOrigem: { numeric },
      tamanhoPrefixoDestino: { numeric },
      alterarOrigemPara: { regexValidaOrigem },
      prefixoOrigem: { regexValida },
      alterarDestinoPara: { regexValida },
      prefixoDestino: { regexValida },
      retiradaOrigem: { numeric },
      addFinalOrigem: { numeric },
      retiradaDestino: { numeric },
      addFinalDestino: { numeric },
      tempo: { required, numeric },
      tronco_id: { required },
    },
  },
}

export const validateComputed = {
  ...validateRegexComputed,
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.acao.description.$dirty) return errors
    !this.$v.form.acao.description.required && errors.push('Descrição é obrigatória.')
    !this.$v.form.acao.description.maxLength && errors.push('Máximo 35 caracteres.')
    return errors
  },
  centroDeCustoErrors() {
    const errors = []
    if (!this.$v.form.acao.centroDeCusto.$dirty) return errors
    !this.$v.form.acao.centroDeCusto.required && errors.push('Centro de custo é obrigatório.')
    return errors
  },
  tamanhoPrefixoOrigemErrors() {
    const errors = []
    if (!this.$v.form.acao.tamanhoPrefixoOrigem.$dirty) return errors
    !this.$v.form.acao.tamanhoPrefixoOrigem.numeric && errors.push('Apenas caracteres numéricos.')
    return errors
  },
  tamanhoPrefixoDestinoErrors() {
    const errors = []
    if (!this.$v.form.acao.tamanhoPrefixoDestino.$dirty) return errors
    !this.$v.form.acao.tamanhoPrefixoDestino.numeric && errors.push('Apenas caracteres numéricos.')
    return errors
  },
  alterarOrigemParaErrors() {
    const errors = []
    if (!this.$v.form.acao.alterarOrigemPara.$dirty) return errors
    !this.$v.form.acao.alterarOrigemPara.regexValidaOrigem && errors.push('Caractere inválido.')
    return errors
  },
  prefixoOrigemErrors() {
    const errors = []
    if (!this.$v.form.acao.prefixoOrigem.$dirty) return errors
    !this.$v.form.acao.prefixoOrigem.regexValida && errors.push('Caractere inválido.')
    return errors
  },
  alterarDestinoParaErrors() {
    const errors = []
    if (!this.$v.form.acao.alterarDestinoPara.$dirty) return errors
    !this.$v.form.acao.alterarDestinoPara.regexValida && errors.push('Caractere inválido.')
    return errors
  },
  prefixoDestinoErrors() {
    const errors = []
    if (!this.$v.form.acao.prefixoDestino.$dirty) return errors
    !this.$v.form.acao.prefixoDestino.regexValida && errors.push('Caractere inválido.')
    return errors
  },
  retiradaOrigemErrors() {
    const errors = []
    if (!this.$v.form.acao.retiradaOrigem.$dirty) return errors
    !this.$v.form.acao.retiradaOrigem.numeric && errors.push('Apenas caracteres numéricos.')
    return errors
  },
  retiradaDestinoErrors() {
    const errors = []
    if (!this.$v.form.acao.retiradaDestino.$dirty) return errors
    !this.$v.form.acao.retiradaDestino.numeric && errors.push('Apenas caracteres numéricos.')
    return errors
  },
  addFinalOrigemErrors() {
    const errors = []
    if (!this.$v.form.acao.addFinalOrigem.$dirty) return errors
    !this.$v.form.acao.addFinalOrigem.numeric && errors.push('Apenas caracteres numéricos.')
    return errors
  },
  addFinalDestinoErrors() {
    const errors = []
    if (!this.$v.form.acao.addFinalDestino.$dirty) return errors
    !this.$v.form.acao.addFinalDestino.numeric && errors.push('Apenas caracteres numéricos.')
    return errors
  },
  tempoErrors() {
    const errors = []
    if (!this.$v.form.acao.tempo.$dirty) return errors
    !this.$v.form.acao.tempo.required && errors.push('Campo obrigatório.')
    !this.$v.form.acao.tempo.numeric && errors.push('Apenas caracteres numéricos.')
    return errors
  },
  troncoIdErrors() {
    const errors = []
    if (!this.$v.form.acao.tronco_id.$dirty) return errors
    !this.$v.form.acao.tronco_id.required && errors.push('Campo obrigatório.')
    return errors
  },
}
